<template>
  <div>
    <main-header-nav :content="'用户列表'"></main-header-nav>
    <div v-loading="loading">
      <div style="width: 90%;min-width: 1024px;margin: 0px auto;">
        <el-button
          type="primary"
          v-on:click="onCreateUser"
          style="width: 100px;"
          >新建用户
        </el-button>
        <el-input
          v-model="userSearchCondition.username"
          placeholder="用户名"
          style="width: 150px;margin-left: calc(100% - 660px);margin-right: 10px;"
        >
        </el-input>
        <el-input
          v-model="userSearchCondition.nickName"
          placeholder="昵称"
          style="width: 150px;"
        >
        </el-input>
        <el-input
          v-model="userSearchCondition.orgnizationName"
          placeholder="组织名称"
          style="width: 150px;margin: 0 10px;"
        >
        </el-input>
        <el-button
          type="primary"
          style="width: 80px;"
          v-on:click="requestPage(1)"
          >筛选
        </el-button>
      </div>
      <el-table
        :data="tableData"
        style="width: 90%;min-width: 1024px;margin: 10px auto;"
        :header-cell-style="hedaerCellStyle"
        :header-row-style="hedaerRowStyle"
        :cell-style="cellStyle"
        :row-style="rowStyle"
      >
        <el-table-column
          prop="username"
          label="用户名"
          min-width="60px"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="nickName"
          label="昵称"
          min-width="60px"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="orgnization.name"
          label="组织名称"
          min-width="150px"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="role.name"
          label="用户类型"
          min-width="80px"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" min-width="70px" align="center">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small"
              >编辑
            </el-button>
            <el-button @click="handleResetPassword(scope.row)" type="text" size="small"
              >重置密码
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px 0px 10px 0px;">
        <el-pagination
          layout="prev, pager, next, jumper"
          :page-size="pageSize"
          :total="totalSize"
          style="text-align: center;"
          @current-change="changePage"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeaderNav from '../common/MainHeaderNav'
export default {
  name: 'UserList',

  components: {
    MainHeaderNav
  },

  methods: {
    handleEdit (row) {
      this.$router.push(`/user_edit/${row.id}`)
    },

    handleResetPassword (row) {
      this.$router.push(`/reset_password/${row.id}`)
    },

    changePage (page) {
      this.requestPage(page)
    },

    requestPage (page) {
      var self = this
      this.$data.userSearchCondition.page = page
      this.$data.userSearchCondition.size = this.$data.pageSize
      this.$data.loading = true
      this.postRequest('/users', this.$data.userSearchCondition)
        .then(resp => {
          self.$data.loading = false
          if (resp && resp.result) {
            self.$data.tableData = resp.result.content
            self.$data.totalSize = resp.result.totalElements
          }
        })
    },

    onCreateUser () {
      this.$router.push('/user_register')
    }
  },

  data () {
    return {
      loading: false,
      tableData: [],
      totalSize: 0,
      pageSize: 10,
      userSearchCondition: {
        username: '',
        nickName: '',
        orgnizationName: '',
        page: 1,
        size: 10
      }
    }
  },

  mounted () {
    this.requestPage(1)
  },

  computed: {
    hedaerCellStyle () {
      return { 'background-color': 'rgba(255, 255, 255, 0)' }
    },
    hedaerRowStyle () {
      return { 'background-color': 'rgba(255, 255, 255, 0)' }
    },
    rowStyle () {
      return { 'background-color': 'rgba(255, 255, 255, 0)' }
    },
    cellStyle () {
      return { 'background-color': 'rgba(255, 255, 255, 0)' }
    }
  }
}
</script>

<style scoped>
.el-table::before {
  height: 0px;
}

/* .el-table, .el-table__expanded-cell {
  background-color: rgba(255, 255, 255, 0.3);
}

.el-table th, .el-table tr {
  background-color: rgba(255, 255, 255, 0.3);
} */
</style>
